import { render } from "./QcTask.vue?vue&type=template&id=52d1aafd&scoped=true"
import script from "./QcTask.vue?vue&type=script&lang=js"
export * from "./QcTask.vue?vue&type=script&lang=js"

import "./QcTask.vue?vue&type=style&index=0&id=52d1aafd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_typescript@5.4.2__webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d1aafd"]])

export default __exports__